<template>

    <m-edit1/>

    <m-single-category-300 v-bind='{...{"categoryLink":null,"relatedPosts":true},...{}}' :style='""' class="" ></m-single-category-300>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleCategory300 from '@moeinmdn/miw-alpha-components/src/package/Category/Single/SingleCategory300';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleCategory300 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
